import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
//import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Theme from './theme';
import { Grid } from '@material-ui/core';

//import 'typeface-roboto';

const useStyles = makeStyles(theme => ({
    root: {
    //    ...theme.typography.button,
       //backgroundColor: "transparant",
    //   padding: theme.spacing(1),
      color: "white", 
      //flexGrow: 1
    },
    righticon: {
          color: "white", 
        },
  }));

const NavBar = () => {
    const classes = useStyles();
    return(
        <div>
            <MuiThemeProvider theme={Theme}>
                <AppBar position="static">
                    <Toolbar>
                        <Grid
                            justify="space-between" // Add it here :)
                            container 
                            //spacing={24}
                        >
                            <Grid item>
                                <h3 className={classes.root}>District Options Online Application</h3>
                            </Grid>
                            <Grid item>
                                <h6 className={classes.righticon}>OUR FOCUS IS ON THE LEARNER</h6>
                            </Grid>
                        </Grid>                          
                    </Toolbar>
                </AppBar>
            </MuiThemeProvider>
        </div>
    )
}
export default NavBar;